import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../api.js';
import { AppShell } from '../components/AppShell.js';
import { Loading, Notice } from '../components/ui.js';

export function AccessPage() {
  const { role: roleParam } = useParams();
  const role = roleParam === 'guest' ? 'GUEST' : roleParam === 'venue' ? 'VENUE' : null;
  const token = useRef(new URLSearchParams(window.location.hash.slice(1)).get('token'));
  const started = useRef(false);
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname);
    if (started.current) return;
    started.current = true;
    if (!role || !token.current) {
      setFailed(true);
      return;
    }
    api<{ nextPath: string }>('/api/access/exchange', {
      method: 'POST',
      body: JSON.stringify({ role, token: token.current }),
    })
      .then((result) => navigate(result.nextPath, { replace: true }))
      .catch(() => setFailed(true));
  }, [navigate, role]);

  return (
    <AppShell language="en">
      <section className="center-card access-card">
        {failed ? (
          <>
            <h1>Secure link unavailable</h1>
            <Notice tone="danger">
              This secure link is invalid or has expired. Use the newest Refindi email for this
              report.
            </Notice>
          </>
        ) : (
          <Loading label="Opening your secure case..." />
        )}
      </section>
    </AppShell>
  );
}
